<!-- this *ngIf will always return `true` -->
<a
  *ngIf="{ type: priceType$ | async } as priceTypeObservable"
  class="product-card"
  fxLayout="column"
  fxLayoutAlign=" start"
  appDisableClickEvent
  [routerLink]="[appStorefrontProductRoute, product?.id]"
  [queryParams]="isSimilarProductRecommendation ? { fromSimilarProducts: 1 } : null"
  [attr.mmTestId]="isProductList ? 'PRODUCT_CATALOG.PRODUCT_CARD' : null"
  [ngClass]="{
    'product-card--topProducts': !isProductList,
    'product-card--productList': isProductList,
    'new-product-card-style': (isNewPLPVariantRestyle$ | async) && isPLP
  }"
  test-target="product-card"
>
  <div
    class="product-card__body-container"
    fxLayout="column"
    fxLayoutAlign="start"
    [ngClass]="{
      'product-card--topProducts__body-container': !isProductList,
      'product-card--productList__body-container': isProductList
    }"
    (click)="onProductClick(product, priceTypeObservable.type, $event)"
  >
    <div class="product-card__sub-body-container" fxLayout="column" fxLayoutAlign="start">
      <div
        class="product-card__image-container"
        [ngClass]="{
          'product-card__image-container--topProducts': !isProductList,
          'product-card__image-container--productList': isProductList
        }"
        test-target="product-card__image-container"
      >
        <a [mmTestTarget]="'product-card-' + product?.mid">
          <img
            loading="lazy"
            [appDefaultImage]="defaultProductImage"
            class="product-card__image"
            [alt]="product?.name"
            [appLazyLoadImage]="product?.image"
            [srcSet]="getSourceSet(product?.image)"
          />
        </a>
      </div>
    </div>

    <div
      class="product-card__body"
      fxLayout="column"
      fxLayoutAlign="space-between start"
      *ngIf="!showOnlyImageOnSimilarProductsCarousel"
      [ngClass]="{
        'product-card__body--productList': isProductList,
        'product-card__body--topProducts': !isProductList
      }"
    >
      <div class="product-card__label__title">
        <div class="product-card__labels-container">
          <app-product-promotion
            [promotion]="!!product?.bestOffer?.promotion"
            [msrpDiscount]="product?.bestOffer?.referencePrice?.discountPercentage"
            [isBlackDealsEnabled]="isBlackDealsEnabled && isBlackDealProduct"
            [hasFixedHeight]="!isProductList"
            [fromProductCard]="true"
          >
          </app-product-promotion>
        </div>

        <p
          class="product-card__title"
          [mmTestTarget]="'product-card-' + product?.name | kebabCase"
          [ngClass]="{
            'product-card__title--topProducts': !isProductList,
            'product-card__title--topProductsEEC':
              !isProductList &&
              (product?.attributes?.energyEfficiencyClass || product?.attributes?.energyEfficiencyRange)
          }"
        >
          {{ product?.name }}
        </p>
      </div>
      <div class="product-card__attributes">
        <app-search-product-energy-efficiency-new
          [energyEfficiencyImage]="product?.attributes?.energyEfficiencyImage"
          [energyConfig]="product?.attributes?.energy_config"
          [productId]="product?.id"
          [eecLabel]="product?.attributes?.eprel"
        >
        </app-search-product-energy-efficiency-new>
        <div
          class="product-card__price"
          fxLayout="column nowrap"
          *ngIf="priceType$ | async as priceType"
          test-target="product-card__price"
        >
          <ng-container *ngIf="product?.bestOffer as bestOffer; else registerPlaceholder">
            <ng-container *ngIf="bestOffer?.referencePrice">
              <span class="product-card__reference-price">
                {{
                  bestOffer?.referencePrice?.priceType === referencePriceTypes.MSRP
                    ? ('CATALOG.CATALOG_PAGE.MSRP.LABEL' | translate)
                    : ''
                }}
                <span class="product-card__reference-price--strikethrough">
                  <ng-container *ngIf="shouldApplyZeroVAT">
                    {{ bestOffer?.referencePrice?.netPrice | currency: bestOffer?.referencePrice?.currency }}
                  </ng-container>
                  <ng-container *ngIf="!shouldApplyZeroVAT">
                    {{
                      (priceType == priceTypes.b2b
                        ? bestOffer?.referencePrice?.netPrice
                        : bestOffer?.referencePrice?.grossPrice
                      ) | currency: bestOffer?.referencePrice?.currency
                    }}
                  </ng-container>
                </span>
              </span>
            </ng-container>
            <div
              class="product-card__price-amount"
              fxLayout="row"
              fxLayoutAlign="start center"
              [ngClass]="{
                'product-card__price-amount--wrap':
                  (priceType == priceTypes.b2b && bestOffer?.price?.netPrice > 999.99) ||
                  (priceType == priceTypes.b2c && bestOffer?.price?.grossPrice > 999.99) ||
                  (shouldApplyZeroVAT && bestOffer?.price?.netPrice > 999.99)
              }"
            >
              <span
                class="product-card__price-amount__main-price"
                [ngClass]="{
                  'product-card__price-amount__price-color': product?.bestOffer?.referencePrice,
                  'product-card__price-amount__main-price-promotion': product?.bestOffer?.referencePrice
                }"
              >
                <ng-container *ngIf="shouldApplyZeroVAT">
                  {{ bestOffer?.price?.netPrice | currency: bestOffer?.price?.currency }}
                </ng-container>
                <ng-container *ngIf="!shouldApplyZeroVAT">
                  {{
                    (priceType == priceTypes.b2b ? bestOffer?.price?.netPrice : bestOffer?.price?.grossPrice)
                      | currency: bestOffer?.price?.currency
                  }}
                </ng-container>
              </span>

              <span class="product-card__base-price product-card__base-price--desktop" *ngIf="bestOffer?.pricePerUnit">
                <ng-container
                  *ngTemplateOutlet="
                    pricePerUnit;
                    context: { priceType: priceType, pricePerUnit: bestOffer.pricePerUnit }
                  "
                ></ng-container>
              </span>
            </div>
            <div class="product-card__price-tax" *ngIf="priceType === priceTypes.b2b" test-target="product-card-vat">
              {{ 'CATALOG.CATALOG_PAGE.PRODUCT.VAT_LABEL' | translate }}
              <ng-container *ngIf="shouldApplyZeroVAT">
                {{ bestOffer?.price?.netPrice | currency: bestOffer?.price?.currency }}
              </ng-container>
              <ng-container *ngIf="!shouldApplyZeroVAT">
                {{ bestOffer?.price?.grossPrice | currency: bestOffer?.price?.currency }}
              </ng-container>
            </div>
            <div class="product-card__base-price product-card__base-price--mobile" *ngIf="bestOffer?.pricePerUnit">
              <ng-container
                *ngTemplateOutlet="
                  pricePerUnit;
                  context: { priceType: priceType, pricePerUnit: bestOffer.pricePerUnit }
                "
              ></ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</a>
<ng-template #registerPlaceholder>
  <span class="product-card__hidden-price">{{
    'CATALOG.CATALOG_PAGE.PRODUCT-CARD.B2B_OFFER_ONLY.LABEL' | translate
  }}</span>
</ng-template>
<ng-template #pricePerUnit let-priceType="priceType" let-pricePerUnit="pricePerUnit">
  <ng-container *ngIf="shouldApplyZeroVAT">
    {{ pricePerUnit?.netPrice | currency: pricePerUnit?.price?.currency }}/{{ pricePerUnit?.unit }}
  </ng-container>
  <ng-container *ngIf="!shouldApplyZeroVAT">
    {{
      (priceType === priceTypes.b2b ? pricePerUnit?.netPrice : pricePerUnit?.grossPrice)
        | currency: pricePerUnit?.currency
    }}/{{ pricePerUnit?.unit }}
  </ng-container>
</ng-template>
